import React from 'react';

interface LeagueHeaderItemProps {
  label: string;
  value: string;
}

const LeagueHeaderItem: React.FC<LeagueHeaderItemProps> = ({ label, value }) => {
  if (!value) return null;
  
  return (
    <div className="flex items-center text-base">
      <span className="text-gray-600 mr-1 text-lg sm:text-xl md:text-2xl">{label}:</span>
      <span className="font-semibold text-lg sm:text-xl md:text-2xl">
        {value}
      </span>
    </div>
  );
};

export default LeagueHeaderItem;